import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { TopicService } from "../../topic-player/services/topic.service";
import { Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class MyLearningResolver  {

  constructor(private topicService: TopicService, @Inject(LOCALE_ID) private localeId: string) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.topicService.getSubjectsByLocale(this.localeId);
  }
}